import { MembershipDiscountNoticeTooltip } from '~/domains/plusMembership/components/Tooltips';
import type { OAISchema } from '~/types/openapi';

import { NonDiscountPrice } from './NonDiscountPrice';
import { PmwkCountdown } from './PmwkCountdown';

import { ThreadIcon16x16 } from '~/assets/icons';

type Props = {
  data: OAISchema['MarketProductDetailsResponseV2'];
};

/**
 * @description 플멤 스탠다드 + 보너스팩 까지 가입한 경우
 * */

export function StandardWithBonuspackPrice({ data }: Props) {
  if (!data.totalDiscountedPrice || data.totalDiscountedPrice === data.price) {
    return <NonDiscountPrice data={data} />;
  }

  return (
    <div className="relative flex flex-col gap-2 rounded-16 border border-solid border-secondary-light px-20 py-16">
      <div className="flex items-center gap-4 text-membershipBlue-text typo-heading200">
        <p className="underline typo-paragraph200-semibold">나의할인가</p>
        <MembershipDiscountNoticeTooltip />
      </div>
      <p className="flex items-center gap-8">
        <strong className="text-membershipBlue-text typo-heading200-bold">
          {data.totalDiscountedPrice?.toLocaleString()}원
        </strong>
        <span className="text-hint typo-paragraph200-regular">
          {data.price ? `${data.price.toLocaleString()}원` : '상담신청 상품'}
        </span>
      </p>
      <div className="flex flex-col ">
        {data.discountResult.items.map((result) => {
          return (
            <p
              className="flex items-center gap-4 text-paragraph typo-paragraph100-regular"
              key={result.description}
            >
              <ThreadIcon16x16 />
              {result.description}
            </p>
          );
        })}
      </div>
      {data.productType !== 'ADVERTISEMENT' && <PmwkCountdown />}
    </div>
  );
}
